import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { capitalize } from 'lodash';
import { PartnerInvitationStatusEnum } from '../../shared/generated';
import { jsx as _jsx } from "react/jsx-runtime";
export var getUserInvitationStatusTextColor = function getUserInvitationStatusTextColor(status) {
  var textColor = '';

  switch (status) {
    case PartnerInvitationStatusEnum.ACCEPTED:
      textColor = '#1CB258';
      break;

    case PartnerInvitationStatusEnum.CANCELED:
    case PartnerInvitationStatusEnum.FAILED:
      textColor = '#DD1F1F';
      break;

    default:
      textColor = '#0E35D1';
      break;
  }

  return textColor;
};
export var UserInvitationStatusView = function UserInvitationStatusView(props) {
  var status = props.status,
      label = props.label,
      className = props.className,
      color = props.color;

  var _useState = useState({}),
      containerStyle = _useState[0],
      setContainerStyle = _useState[1];

  var _useState2 = useState(''),
      showText = _useState2[0],
      setShowText = _useState2[1];
  /**
   * effects
   */


  useEffect(function () {
    evaluateTextInfo();
  }, [status]);
  /**
   * methods
   */

  var evaluateTextInfo = function evaluateTextInfo() {
    var textColor = color;
    var showText = label || '';

    if (!textColor) {
      textColor = getUserInvitationStatusTextColor(status);
    }

    if (!label) {
      showText = status;
    }

    setShowText(showText);
    setContainerStyle({
      borderColor: "".concat(textColor),
      color: "".concat(textColor)
    });
  };

  return /*#__PURE__*/_jsx("div", {
    style: containerStyle,
    className: clsx('flex flex-row rounded-md border px-[8px] py-[6px] text-sm font-bold', className),
    children: capitalize(showText === null || showText === void 0 ? void 0 : showText.replaceAll('_', ' '))
  });
};